import React from "react";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Select, MenuItem, Autocomplete, TextField } from "@mui/material";
import { GlobalData } from "../../util/GlobalData";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import WorkIcon from '@mui/icons-material/Work';



export default function DirectoryFilter({ title = "Filters", companyList, pays, setFilteredList, urlActivity }) {
    const { t } = useTranslation()
    const [isFiltered, setisFiltered] = useState(false)

    const [search, setSearch] = useState("");
    const [country, setCountry] = useState(localStorage.getItem("country") || "all");
    const [activity, setActivities] = useState(urlActivity || "all");

    useEffect(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('activity', activity);
        window.history.pushState({}, '', url);
    }, [activity])

    useEffect(() => {
        if (country != "all" || activity != "all" || search) {
            applyFilter()
        } else {
            setFilteredList(companyList)
            setisFiltered(false)
        }
    }, [search, country, activity])


    const applyFilter = () => {
        setisFiltered(true)


        let result = companyList;



        result = filterSearch(result)
        result = filterPays(result);
        result = filterActivities(result);


        setFilteredList(result)
    }


    const clearFilter = () => {
        setSearch("")
        setCountry(localStorage.getItem("country") || "all")
        setActivities("all")


        setisFiltered(false)
    };




    const filterSearch = (array) => {
        if (search) {
            return array.filter((company) => {
                return (
                    company.nom
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                    company.email
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    ||
                    company.ville
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    ||
                    company.adresse
                        .toLowerCase()
                        .includes(search.toLowerCase())
                );
            })
        } else {
            return array;
        }
    };







    const filterPays = (array) => {

        if (country != "all") {
            let newArray = [];
            array.forEach((item) => {

                if (item.pays == country) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };





    const filterActivities = (array) => {
        if (activity != "all") {
            let newArray = [];
            array.forEach((item) => {
                if (item.activite == activity) {
                    newArray.push(item);
                }
            });
            return newArray;
        } else {
            return array;
        }
    };














    return (
        <div className="col-md-3">
            <div className="d-flex align-items-center justify-content-center">

                <div className="filtre-marketplace">
                    <div className="filter-header">{title}</div>

                    <div className="marketplace-search-position has-search">
                        <i className="fa fa-search form-control-feedback"></i>
                        <input
                            type="text"
                            className="form-control input-search-marketplace"
                            placeholder={t("catalog3.1")}
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                            }}
                        />
                    </div>

                    <div className="filter-header-1">
                        <div style={{ marginTop: 3 }}>{t("Filtres.1")}</div>
                        {isFiltered && (
                            <>
                                <span onClick={clearFilter} className="remove-all-filter"><i className="fas fa-times"></i> &nbsp; {t("resetFilter")}</span>
                            </>
                        )}
                    </div>


                    <>
                        <hr />
                        <div className="filter-content">


                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("user.pays")}
                                </h5>
                                <Autocomplete
                                    disablePortal
                                    fullWidth
                                    options={[{ label: t("all"), value: "all" }, ...(pays.map((val) => ({
                                        label: val.name,
                                        value: val.name
                                    })))]}
                                    value={country}
                                    onChange={(event, newValue) => {
                                        setCountry(newValue?.value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField  {...params} variant="outlined" />
                                    )}
                                    disableClearable={true}
                                />


                            </div>
                            <hr />


                            <div className="categories">
                                <h5 className="filter-section-title" style={{ fontSize: 15 }}>
                                    {t("user.activity")}
                                </h5>
                                <Select IconComponent={WorkIcon} value={activity} onChange={(e) => { setActivities(e.target.value) }} fullWidth >
                                    <MenuItem value={"all"}>
                                        {t("all")}
                                    </MenuItem>
                                    {GlobalData.user.activities.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {t("user.activities." + val)}
                                        </MenuItem>
                                    ))}
                                </Select>


                            </div>
                            <hr />



                        </div>
                    </>

                </div>
            </div>
        </div>

    )
}











export function DirectoryOrder({ items, setOrderedItems }) {
    const { t } = useTranslation()
    const [order, setOrder] = useState(0)


    useEffect(() => {
        onChangeOrder(order)
    }, [items])



    const onChangeOrder = (value) => {
        let orderedItems = []


        if ([0, 1].includes(value)) {
            // view order
            orderedItems = [...items].sort((a, b) => Number(a.datecreation) - Number(b.datecreation))
        }


        // reverse if not ascending order
        if ([1].includes(value)) {
            orderedItems.reverse()
        }

        setOrder(value)
        setOrderedItems(orderedItems)
    }

    return (
        <div className="col-md-12">
            <div className="section-title seemore endsection">
                <div className="plus">
                    <div >
                        <span className="text-input">{t('catalog1.1')}</span>
                    </div>
                    <div>
                        <Select IconComponent={SwapVertIcon} value={order} onChange={(e) => { onChangeOrder(e.target.value) }} fullWidth >
                            <MenuItem value={0}>
                                {t("newestToOldest")}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t("oldestToNewest")}
                            </MenuItem>
                        </Select>


                    </div>
                </div>
            </div>
        </div>
    )
}